import { vuexEventPathGenerator } from '@/utils';
import { mutationType } from './mutations';
export const actionType = {
    setIsOpenModalOrderInfo: 'setIsOpenModalOrderInfo',
};
export const modalOrderInfoActionType = vuexEventPathGenerator(actionType, 'modalOrderInfo');
const action = {
    /** 주문모달 출력 여부 */
    [actionType.setIsOpenModalOrderInfo]({ commit }, orderId) {
        commit(mutationType.SET_IS_OPEN_MODAL_ORDER_INFO, orderId);
    },
};
export default action;
